// @flow

import { PostHog } from 'posthog-js'

import FeatureFlag from './posthog/FeatureFlag.vue'

export default {
  install (Vue: any, posthogInstance: typeof PostHog): void {
    if (posthogInstance) Vue.prototype.$posthog = posthogInstance

    Vue.component('FeatureFlag', FeatureFlag)

    Vue.prototype.$isFeatureEnabled = function (featureName: string, variantGroups: Array<string> = ['test']): boolean {
      return this.$posthog && Array.isArray(variantGroups) && variantGroups.includes(this.$posthog.getFeatureFlag(featureName))
    }
  }
}
